import Vue from "vue";
import VueRouter from "vue-router";
// import Home from '../views/Home.vue';
import store from "../store";

Vue.use(VueRouter);

const routes = [
    {
        path: "/auth",
        name: "AuthLayout",
        component: () => import("../layouts/AuthLayout.vue"),
        children: [
            {
                path: "login",
                name: "Login",
                component: () => import("../views/Login.vue"),
                meta: { requiresGuest: true },
            },
        ],
    },
    {
        path: "/",
        name: "Home",
        component: () => import("../layouts/MainLayout.vue"),
        meta: { requiresAuth: true },
        children: [
            {
                path: "jobcards",
                name: "JobCards",
                meta: { requiresAuth: true },
                component: () => import("../views/JobCards"),
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.jobcards.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "jobcard/:id",
                name: "JobCard",
                meta: { requiresAuth: true },
                component: () => import("../views/JobCard.vue"),
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.jobcards.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "trucks",
                name: "Truck",
                component: () => import("../views/Truck.vue"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.trucks.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "drivers",
                name: "Driver",
                component: () => import("../views/Drivers"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.drivers.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "workshops",
                name: "Workshop",
                component: () => import("../views/Workshop.vue"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.workshops.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "external-workshops",
                name: "ExternalWorkshop",
                component: () => import("../views/ExternalWorkshop"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.external_workshops.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "truck-types",
                name: "TruckTypes",
                component: () => import("../views/TruckType"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.truck_types.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "users",
                name: "User",
                component: () => import("../views/User"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.users.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "permissions",
                name: "Permission",
                component: () => import("../views/Permission"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.roles.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "tire-brands",
                name: "TireBrands",
                component: () => import("../views/TireBrands"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.tire_brands.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "truck-brands",
                name: "TruckBrands",
                component: () => import("../views/TruckBrands"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.truck_brands.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "items",
                name: "Items",
                component: () => import("../views/Items"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.items.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "item-groups",
                name: "ItemGroups",
                component: () => import("../views/Items"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.item_groups.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "reports",
                name: "Reports",
                component: () => import("../views/ReportsView.vue"),
                meta: { requiresAuth: true },
                children: [
                    {
                        path: "",
                        component: () => import("../components/ReportList.vue")
                    },
                    {
                        path: "malfactions-summary",
                        component: () => import("../components/MalfactionsSummaryReport.vue")
                    },
                    {
                        path: "malfactions-report-by-truck-type",
                        component: () => import("../components/MalfactionsReportByTruckType.vue"),
                        props: route => ({ query: route.query })
                    },
                    {
                        path: "malfactions-report-by-truck",
                        component: () => import("../components/MalfactionsReportByTruck.vue"),
                        props: route => ({ query: route.query })
                    },
                    {
                        path: "malfactions-report-by-truck-details",
                        component: () => import("../components/MalfactionsReportByTruckDetails.vue"),
                        props: route => ({ query: route.query })
                    },
                    {
                        path: "malfactions-report-by-truck-plate",
                        component: () => import("../components/MalfactionsReportByTruckPlateNumber.vue"),
                        props: route => ({ query: route.query })
                    }
                ]
            },
            {
                path: "mileage-readings",
                name: "MileageReading",
                component: () => import("../views/MileageReadings"),
                meta: { requiresAuth: true },
                beforeEnter: (to, from, next) => {
                    if (store.state.authentication.authorizations) {
                        if (store.state.authentication.authorizations.mileage_readings.read) next();
                        else next(false);
                    } else next("/");
                },
            },
            {
                path: "failure-master-view",
                name: "FailureMasterView",
                component: () => import("../views/FailureMasterView")
            },
            {
                path: "maintenance-report",
                name: "MaintenanceReport",
                component: () => import("../views/MaintenanceReport.vue")
            }
        ],
    },
];
const router = new VueRouter({
    mode: "hash",
    base: "/",
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters["authentication/isLoggedin"]) {
            if (to.path == "/auth/login") next(false);
            else next();
        } else next("/auth/login");
    } else if (to.matched.some((record) => record.meta.requiresGuest)) {
        if (store.getters["authentication/isLoggedin"]) next(false);
        else next();
    } else {
        next();
    }
});

export default router;
